let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gp2vZ")).then(() => parcelRequire('aUjDR'));